import { useEffect } from "react";
import { X } from "@phosphor-icons/react";
import LeadForm from "@/pages/LeadForm";

// Full quote form in a modal — used by "Hold this slab" on the public carousels.
export const QuoteDialog = ({ open, onClose, color = "", message = "", source = "", title, testId = "site-quote-dialog" }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      className="site site-overlay fixed inset-0 z-[90] flex items-end justify-center bg-[#1a1a18]/60 p-0 sm:items-center sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={title || "Get a quote"}
      data-testid={testId}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="relative max-h-[92vh] w-full max-w-2xl overflow-y-auto bg-[color:var(--s-surface)] p-6 shadow-2xl  sm:p-10">
        <button
          type="button"
          onClick={onClose}
          data-testid={`${testId}-close`}
          aria-label="Close"
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--s-line)] text-[color:var(--s-mute)] transition-colors duration-300 hover:text-[color:var(--s-ink)]"
        >
          <X size={16} weight="bold" />
        </button>
        {title && (
          <h3 className="s-hx mb-6 pr-12 text-2xl sm:text-3xl" data-testid={`${testId}-title`}>
            {title}
          </h3>
        )}
        <div className="lead-embedded">
          <LeadForm embedded prefillColor={color} prefillMessage={message} source={source} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};
